<div class="order-section-heading">
  <div class="order-section-title">
    <ng-content select="pxw-icon" />
    {{ title() }}
  </div>
  @if (editEnabled()) {
    <pxw-tooltip
      [disabled]="!disabledEditTooltip()"
      [text]="disabledEditTooltip() || ''"
      [offsetY]="10"
    >
      <pxw-button
        size="md"
        [rounded]="true"
        appareance="bare"
        color="blue"
        (click)="edit.emit()"
        [disabled]="disabledEditButton()"
      >
        <pxw-icon icon="edit" />
      </pxw-button>
    </pxw-tooltip>
  }
</div>
<div class="order-section-body">
  <ng-content />
</div>
